import { Controller } from '@hotwired/stimulus'
import { useMutation } from 'stimulus-use'

export default class extends Controller {
  connect() {
    useMutation(this, { attributes: true, childList: true, subtree: true  });
    this.count();
  }

  count() {
    const table = this.element.closest('table');
    if (!table) return;

    const rows = Array.from(table.rows);
    const visibleRowsCount = rows.filter(row => row.offsetParent !== null).length;

    const countDisplay = document.getElementById("table-count");
    if (countDisplay) {
      countDisplay.textContent = Math.max(0, visibleRowsCount - 1);
    }
  }


  mutate(entries) {
    this.count();
  }
}